import type { PageLoad } from "./$types";

export const prerender = true;

export const load: PageLoad = () => {
  return { title: "Privacy Policy | Modal", ogTitle: "Privacy Policy" };
};
